import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { TablePagination } from '@material-ui/core';

export const Pagination = ({ count = 0, rowsPerPage = [10, 25, 50, 100], labelRowsPerPage, onChange = () => {} }) => {
  const { messages: intlMessages } = useIntl();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(rowsPerPage[0]);

  const onChangePage = (_, newPage) => {
    setPage(newPage);
    onChange({ page: newPage, pageSize });
  };

  const onChangeRowsPerPage = event => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPage(0);
    onChange({ page: 0, pageSize: newPageSize });
  };

  const labelDisplayedRows = ({ from, to, count }) =>
    `${from}-${to} ${intlMessages['table.of']} ${count !== -1 ? count : `${intlMessages['table.moreThan']} ${to}`}`;

  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPage}
      component="div"
      rowsPerPage={pageSize}
      count={count}
      onPageChange={onChangePage}
      labelRowsPerPage={labelRowsPerPage || intlMessages['common.table.rowsPerPage']}
      labelDisplayedRows={labelDisplayedRows}
      onRowsPerPageChange={onChangeRowsPerPage}
      page={page}
    />
  );
};

Pagination.propTypes = {
  count: PropTypes.number,
  rowsPerPage: PropTypes.arrayOf(PropTypes.number),
  labelRowsPerPage: PropTypes.string,
  onChange: PropTypes.func
};
